export default __webpack_public_path__ + "static/media/10.3614d7aa.JPG";